import React from 'react';

const IconButton = ({ 
  Icon, 
  href, 
  external = false,
  className = "",
  iconProps = {} 
}) => {
  const buttonProps = external ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {};

  return (
    <a 
      href={href}
      className={`text-primary hover:text-secondary ${className}`}
      {...buttonProps}
    >
      <Icon
        sx={{
          width: { xs: 24, sm: 32, lg: 40 },
          height: { xs: 24, sm: 32, lg: 40 },
          color: "inherit",
          ...iconProps
        }}
      />
    </a>
  );
};

export default IconButton; 